import React, { FC } from "react";

interface CustomModalProps {
  isVisible: boolean;
  title: string;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
  width: string;
  height?: string; // Optional height prop
  bg?: string;
}

const CustomModal: FC<CustomModalProps> = ({
  isVisible,
  title,
  onClose,
  footer,
  children,
  width,
  height = "auto", // Default height is auto
  bg = "bg-revampLightBlueBackground "
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div
        className={`${bg} shadow-lg z-10 rounded-2xl ${width} flex flex-col`}
        style={{ maxHeight: height }}
      // style={{ maxHeight: "80vh" }}
      >
        <div className={`flex justify-between border-b-2 rounded-2xl px-10 border-themeCardBorder bg-revampBlue items-center py-4 mb-3`}>
          <h2 className="text-xl font-semibold text-white">{title}</h2>
        </div>
        <div className="px-10 py-6 overflow-y-auto flex-grow">
          <div className="mb-4">{children}</div>
        </div>
        <div className={`px-10 py-4 ${bg} flex justify-end space-x-4 border-t border-themeCardBorder rounded-2xl`}>
          {footer}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
